import { createSlice } from '@reduxjs/toolkit';
import { DateNight, Nullable } from '../../types';
import { Paginated } from '../../services/api-handlers/pagination';
import { takeOne } from '../../helpers/store';
import {
    createDateNight,
    deleteDateNight,
    getAllDateNights,
    getDateNight,
    listDateNights,
    updateDateNight,
} from '../thunks/date-night-thunks';
import { ReducerState } from '../configure-store';

export interface DateNightState extends ReducerState {
    data: Paginated<DateNight>;
    current: Nullable<DateNight>;
}

const initialState: DateNightState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'date-night',
    initialState,
    reducers: {
        resetDateNightCurrent: (state: DateNightState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listDateNights.pending, takeOne.pendingActionCase)
            .addCase(listDateNights.rejected, takeOne.rejectedActionCase)
            .addCase(listDateNights.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })

            .addCase(getAllDateNights.pending, takeOne.pendingActionCase)
            .addCase(getAllDateNights.rejected, takeOne.rejectedActionCase)
            .addCase(getAllDateNights.fulfilled, takeOne.fulfilledActionCase)

            .addCase(getDateNight.pending, takeOne.pendingActionCase)
            .addCase(getDateNight.rejected, takeOne.rejectedActionCase)
            .addCase(getDateNight.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })

            .addCase(createDateNight.pending, takeOne.pendingActionCase)
            .addCase(createDateNight.fulfilled, takeOne.fulfilledActionCase)
            .addCase(createDateNight.rejected, takeOne.rejectedActionCase)

            .addCase(updateDateNight.pending, takeOne.pendingActionCase)
            .addCase(updateDateNight.fulfilled, takeOne.fulfilledActionCase)
            .addCase(updateDateNight.rejected, takeOne.rejectedActionCase)

            .addCase(deleteDateNight.pending, takeOne.pendingActionCase)
            .addCase(deleteDateNight.fulfilled, takeOne.fulfilledActionCase)
            .addCase(deleteDateNight.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetDateNightCurrent } = slice.actions;

export default slice.reducer;
